import React, { useState } from 'react';
import { connect } from 'react-redux';
import { triggerPooledAllotment } from '../../../actions/users.js';
import { Text, Button, Modal } from '@simplybenefits/sb-ui-library';
import SetAllotmentsModal from './SetAllotmentsModal.js';
 
const styles = {
    allotmentButtons: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    balancesButton: {
        textTransform: "capitalize",
        fontSize: 16,
        marginBottom: '20px'
    },
    allotmentButton: {
        marginLeft: "10px",
        textTransform: "capitalize",
        fontSize: 16,
        marginBottom: '20px'
    }
};

/**
 * Component for managing user allotments and balances
 * @param {Object} props - Component props
 * @param {Object} props.currentUser - Current user object containing coverage and meta data
 * @param {Function} props.dispatch - Redux dispatch function
 * @param {boolean} props.loader - Loading state for modals
 * @returns {JSX.Element} AllotmentsContainer component
 */
const AllotmentsContainer = ({
    currentUser,
    dispatch,
    loader
}) => {
    const { coverage, meta } = currentUser;
    const [ showAllotmentBalanceModal, setShowAllotmentBalanceModal ] = useState(false);
    const [ showTriggerAllotmentConfirmationModal, setShowTriggerAllotmentConfirmationModal ] = useState(false);

    /**
     * Triggers pooled allotment for the current user and closes the confirmation modal on success
     * @returns {Promise<void>}
     */
    const triggerAllotmentAndCloseModal = async () => {
        const success = await dispatch(triggerPooledAllotment(meta.userID));
        if (success) {
            setShowTriggerAllotmentConfirmationModal(false);
        }
    };
    
    return (
        <>
            <div style={ styles.allotmentButtons }>
                {
                    coverage.spendingAccounts.health.hasBenefit || coverage.spendingAccounts.lifestyle.hasBenefit ?
                        <Button
                            color={'primary'}
                            onClick={() => setShowAllotmentBalanceModal(true)}
                            customStyle={styles.balancesButton}
                        >
                            Set Allotments & Balances
                        </Button>
                        : null
                }

                {
                    coverage.spendingAccounts.meta.isPooled ?
                        <Button
                            color={'primary'}
                            onClick={() => setShowTriggerAllotmentConfirmationModal(true)}
                            disabled={Boolean(coverage.spendingAccounts.meta.pendingMaximumSetting)}
                            customStyle={styles.allotmentButton}
                        >
                            Trigger Allotment Setting
                        </Button>
                        :
                        null
                } 
            </div>

            <Modal
                open={showTriggerAllotmentConfirmationModal}
                onClose={() => setShowTriggerAllotmentConfirmationModal(false)}
                title="Are you sure?"
                primaryButton={{
                    label: "Confirm Allotment Trigger",
                    onClick: () => triggerAllotmentAndCloseModal()
                }}
                loader={loader}
            >
                <Text medium margin="10px 0 0 0">
                    The member will be notified to reallocate their HSA and LSA maximums
                </Text>
            </Modal>
        
            <SetAllotmentsModal
                showModal={showAllotmentBalanceModal}
                hideModal={() => setShowAllotmentBalanceModal(false)}
            />
        </>
    );
};

/**
 * Maps Redux state to component props
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    currentUser: state.users.currentUser
});

export default (connect(mapStateToProps)(AllotmentsContainer));